<div class="planning-card" *ngIf="!!content">
  <div class="icon mb-3 mb-lg-5">
    <img [src]="content?.thumbImg?.url" [alt]="content?.title" />
  </div>
  <h3 class="mb-3">{{content?.title}}</h3>
  <p class="text-16 mb-0">{{content?.info}}</p>
</div>
